import { CUSTOMER_SLUG, INSTANCE_SLUG, ADC_CONFIG } from '../constants'

export const createUserProfileUrl = (userId: string) => {
  if (ADC_CONFIG?.useVanityUrl) {
    return `/${INSTANCE_SLUG}/new/profile/${userId}/about`
  }

  return `/a/${CUSTOMER_SLUG}/${INSTANCE_SLUG}/new/profile/${userId}/about`
}
